"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTES = exports.MODERN_BASE_PATH = void 0;
exports.MODERN_BASE_PATH = '/m';
exports.ROUTES = {
    ACCESS_DENIED: '/access-denied',
    AUTHORIZE: '/authorize',
    CMS: '/cms',
    CMS_COLLECTIONS: '/cms/collections',
    CMS_RELEASES: '/cms/releases',
    HOME: '/',
    MODERN_HOME: exports.MODERN_BASE_PATH,
    MODERN_RULES: `${exports.MODERN_BASE_PATH}/rules`,
    KNOWLEDGE_BASE: `${exports.MODERN_BASE_PATH}/knowledge-base`,
    PAGE_GROUPS: '/cms/page-groups',
    PAGES: '/cms/pages',
    PAGE_NOT_FOUND: '/page-not-found',
    PROJECT_TIMELINES: `${exports.MODERN_BASE_PATH}/project-planning/timeline`,
    PROMO_CODES: '/promo-codes',
    RULES: '/rules',
    VENDORS: '/vendors',
    VENDOR_CODES: '/vendors/vendor-codes',
    VENDOR_CODES_HOME_WARRANTY: '/vendors/vendor-codes-homewarranty',
    VENDOR_CODES_COMMERCIAL: '/vendors/vendor-codes/commercial',
    VENDOR_CODES_COMMERCIAL_HOME_WARRANTY: '/vendors/vendor-codes/commercial/home-warranty',
    VENDOR_CODES_DIRECT_MAIL: '/vendors/vendor-codes/direct-mail',
    VENDOR_CODES_INTERNET: '/vendors/vendor-codes/internet',
    VENDOR_CODES_INTERNET_HOME_WARRANTY: '/vendors/vendor-codes/internet/home-warranty',
};
